export default __webpack_public_path__ + "static/media/scan-documents-error.efc587ec.svg";